<script>
  import { onMount } from "svelte";
  import { makeWebsiteRequest } from "../../Common/tools";

  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";

  export let filters = [],
    funnel = null,
    period = null;

  export function reload() {
    load(0);
  }

  let loading = true,
    initialLoad = true,
    currentPage = 0,
    pagesCount = 0,
    itemsCount = 0,
    table = null,
    allOrdersTotal = 0,
    allOrdersCount = 0;

  let tableColumns = [
    { key: "name", label: M.CUSTOMER_NAME, class: "flex-1 mw-240 flex align-center" },
    { key: "email", label: M.EMAIL, class: "flex-none" },
    { key: "total", label: M.REVENUE, class: "flex-none mw-140" },
    { key: "count", label: M.ORDERS, class: "flex-none mw-140" }
  ];

  let tableData = {
    columns: tableColumns,
    rows: []
  };

  let load = async (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;

    if (page === 0) {
      tableData.rows = [];
    } else if (currentPage + 1 >= pagesCount) {
      return;
    }
    loading = true;

    let response = await makeWebsiteRequest({
      action: "getOrderStats",
      method: "post",
      data: {
        type: "top-performers",
        grouping: "customers",
        page: page,
        funnel: funnel,
        from: period && period.from ? External.Tools.dateToISOStr(period.from) : null,
        to: period && period.to ? External.Tools.dateToISOStr(period.to) : null,
        filters: JSON.stringify(filters)
      }
    });

    loading = false;
    if (!response.data) return;

    let customers = response.data.customers;

    currentPage = page;
    pagesCount = customers.pagesCount;
    itemsCount = customers.count;

    if (page === 0) {
      allOrdersCount = response.data.orders;
      allOrdersTotal = response.data.sales;
    }

    customers.items.forEach((item) => {
      item.total = External.Tools.currencyToStrWithSymbol(item.total);
    });

    if (table) {
      table.addRows(customers.items);
    }
  };

  let onNext = () => {
    load(currentPage + 1);
  };

  let onClickRow = (row) => {
    if (!row.id) {
      return;
    }
    External.Tools.closeAllPopups(() => {
      External.CPanel.goToUrl("/me/crm/contact/" + row.id);
    });
  };

  onMount(() => {
    load(0);
  });
</script>

<Table
  bind:this={table}
  hasSelection={false}
  activeColumns={tableData.columns}
  data={tableData.rows}
  loading={loading}
  hideHeadOnLoad={true}
  nextPage={onNext}
  onClick={onClickRow}
  tableClass={"mt-25"}>
  <div class="col20 f-left coming-soon-block">
    <div class="col20 f-left t-center mb-25">
      <span class="material-icons-outlined fingerprint-icon" style="background: #f5f6fa;"> bubble_chart </span>
    </div>
    <div class="col20 f-left t-center">
      <h3>{M.NO_DATA_YET}</h3>
    </div>
  </div>
</Table>
